(function ($) {

    $.fn.camcomWooCommerce = function () {

        const init = function () {

            console.log('CamCom WooCommerce');

            $('.slider-gallery__content').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.slider-gallery__navigation',
                arrows: false,
                dots: false,
                adaptiveHeight: false,
                infinite: false
            });


            $('.slider-gallery__navigation').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.slider-gallery__content',
                dots: false,
                arrows: false,
                adaptiveHeight: false,
                centerMode: true,
                //centerPadding: '100px',
                focusOnSelect: true

            });

            camcomLightbox('.slider-gallery', '.slider-gallery__content .slick-slide');

            $('.single-product-variation-radio-wrapper').find('input[checked="checked"]').parent().addClass('is-active');

            $('.variation-radio-label').on('click', function (event) {

                $('.variation-radio-label').removeClass('is-active');
                $(this).addClass('is-active');

            });

            $(document).on('show_variation', 'single_variation_wrap', (e) => {

                let hasText = !!$.trim($('.woocommerce-variation.single_variation').text());

                $('.woocommerce-variation.single_variation').stop().removeAttr('style').toggle(hasText);

            }).on('hide_variation', (e) => {

                $('.woocommerce-variation.single_variation').stop().hide();

            });

            $('.cart').on('click', '.ajax_add_to_cart', function () {

                $(this).html('Adding...');

            });

            $('.atc').on('click', '.atc__quantity__button', function (event) {

                event.preventDefault();

                console.log('Change cart quant');

                var elem = $(this),
                    increment = elem.data('increment'),
                    input = elem.parent().find('input[type="number"]'),
                    inputMin = input.attr('min'),
                    inputMax = input.attr('max'),
                    inputValue = parseInt(input.val()),
                    newInputValue;

                if (!inputMax) {

                    inputMax = 100;

                }

                $('.cart').find('button[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false);

                switch (increment) {

                    case 'plus':

                        if (inputValue < inputMax) {

                            newInputValue = inputValue + 1;

                            input.val(newInputValue);

                            if (newInputValue == inputMax) {

                                elem.attr('disabled', 'disabled');
                                elem.siblings(elem).removeAttr('disabled');

                            } else {

                                elem.siblings(elem).removeAttr('disabled');

                            }

                        }

                        break;

                    case 'minus':

                        if (inputValue > inputMin) {

                            newInputValue = inputValue - 1;

                            input.val(newInputValue);

                            if (newInputValue == inputMin) {

                                elem.attr('disabled', 'disabled');
                                elem.siblings(elem).removeAttr('disabled');

                            } else {

                                elem.siblings(elem).removeAttr('disabled');

                            }

                        }

                        break;

                }

            });

            $('.woocommerce').on('click', '.trigger-update_cart', function (event) {

                event.preventDefault();

                $('.woocommerce-cart-form').find('button[name="update_cart"]').prop('disabled', false).attr('aria-disabled', false).trigger('click');

            });


            $('.atc__submit:not(.atc__submit--composite)').on('click', function (event) {

                event.preventDefault();

                var elem = $(this),
                    quantity = 1,
                    buttonText = elem.text(),
                    productId, bundledProductIds = [],
                    variationId;

                if (elem.hasClass('atc__submit--variation') && $('input[name="variation_id"]').val() < 1) {

                    console.log('Abort Add To Cart');
                    return;

                }

                if ($('.bundle_sells_form').length) {

                    $('.bundle_sells_form .cart').each(function (index, elem) {

                        bundledProductIds.push($(elem).data('product_id'));

                    });

                }

                if (elem.is('a')) {

                    productId = elem.data('product_id');

                } else {

                    if (elem.hasClass('atc__submit--variation')) {

                        productId = $('input[name="product_id"]').val();
                        variationId = $('input[name="variation_id"]').val();

                    } else {

                        productId = elem.val();

                    }

                    quantity = elem.parents('.atc').find('.atc__quantity__input').val();

                }

                console.log('Adding:', productId);
                console.log('Adding variation:', variationId);
                console.log('Adding to cart:', quantity);

                if (productId) {

                    $.ajax({
                        url: ajax_variables.ajax_url,
                        method: 'POST',
                        data: {
                            'action': 'camcom_add_to_cart',
                            'product_id': productId,
                            'bundled_product_ids': bundledProductIds,
                            'variation_id': variationId,
                            'quantity': quantity
                        },
                        beforeSend: function () {
                            elem.text('Adding...');
                        },
                        success: function (data) {

                            $('.camcom').after(data).promise().done(function () {

                                var cartModal = $('body').modal();

                                $('.site-head__actions__basket__count').text(parseInt($('.site-head__actions__basket__count').text()) + 1);

                                cartModal.modalOpen($('#modal_cart'));

                                elem.text(buttonText);

                            });

                        }

                    });

                }

            });

            $('.atc__submit--composite').on('click', function (event) {

                event.preventDefault();

                //console.log('Adding Composite Product to Cart');

                var elem = $(this),
                    buttonText = elem.text(),
                    productElem = $('.composite_data'),
                    productId = productElem.data('container_id');

                var componentsElem = $('.component_options'),
                    componentConfig = {},
                    ajaxAction = 'camcom_add_composite_to_cart';

                componentsElem.find('select').each(function (index, elem) {

                    var componentId = $(elem).data('component_id'),
                        componentProduct = $(elem).val();

                    console.log('Product ID: ', productId);
                    console.log('Component ID: ', componentId);
                    console.log('Component Product: ', componentProduct);

                    if (componentProduct) {

                        componentConfig[componentId] = {product_id: componentProduct};

                    }

                });

                if (Object.keys(componentConfig).length === 0) {

                    ajaxAction = 'camcom_add_to_cart';
                    //console.log('Not Composite');

                } else {

                    //console.log('Composite');

                }

                //console.log(componentConfig);
                //console.log(ajaxAction);

                $.ajax({
                    url: ajax_variables.ajax_url,
                    type: 'POST',
                    data: {
                        'action': ajaxAction,
                        'product_id': productId,
                        'component_config': componentConfig,
                        'quantity': $('.atc__quantity__input').val()
                    },
                    beforeSend: function () {
                        elem.text('Adding...');
                    },
                    success: function (data) {

                        $('.camcom').after(data).promise().done(function () {

                            var cartModal = $('body').modal();

                            $('.site-head__actions__basket__count').text(parseInt($('.site-head__actions__basket__count').text()) + 1);

                            cartModal.modalOpen($('#modal_cart'));

                            elem.text(buttonText);

                        });

                    }

                });

            })

        };

        /*$('.order-account form').on('submit', function (event) {

            event.preventDefault();

            $('#ugp_set_password').trigger('click');

        });

        $('#ugp_set_password').on('click', function (event) {

            event.preventDefault();

            var form = $(this).parents('.form'),
                userLogin = form.find('#ugp_customer_email'),
                userPass = form.find('#ugp_customer_password'),
                formSubmit = $(this),
                formError = form.find('.form__error');

            if (userPass.val().length >= 8) {

                formSubmit.val('Working...');
                formError.addClass('is-hidden').empty();

                $.ajax({
                    url: ajax_variables.ajax_url,
                    method: 'POST',
                    data: {
                        'action': 'ugp_trigger_reset_password',
                        'user_email': userLogin.val(),
                        'user_password': userPass.val()
                    },
                    success: function (data) {

                        formSubmit.val('Set Password').blur();
                        userPass.val('');

                    }
                });

            } else {

                formSubmit.blur();
                formError.removeClass('is-hidden').html('Password must be at least 8 characters long');

            }

        });

        $('button[name="apply_coupon"]').on('click', function (event) {

            console.log('Apply Voucher');

        });*/

        init();

        return this;

    }

}(jQuery));